import {
  RectangleWithCustomRadius,
  type RectangleWithCustomRadiusProps,
} from '../../../components/rectangle-with-custom-radius/RectangleWithCustomRadius';
import { getMinPossibleWidth } from '../../../components/rectangle-with-custom-radius/RectanglePath';

type HorizontalBarWithPlaceholderProps = Omit<
  RectangleWithCustomRadiusProps,
  'animationDirection' | 'background'
> & {
  animateFromY?: number | undefined;
  placeholderWidth: number;
  placeholderColor: string;
  background: { color: string };
};

export const HorizontalBarWithPlaceholder = (
  props: HorizontalBarWithPlaceholderProps,
) => {
  const { animateFromY, placeholderWidth, placeholderColor, ...rest } = props;

  const minPossibleWidthForPath = getMinPossibleWidth({
    topLeftRadius: rest.topLeftRadius || 0,
    topRightRadius: rest.topRightRadius || 0,
    bottomLeftRadius: rest.bottomLeftRadius || 0,
    bottomRightRadius: rest.bottomRightRadius || 0,
  });

  return (
    <svg width={placeholderWidth} height={rest.height} aria-hidden>
      <RectangleWithCustomRadius
        {...rest}
        width={placeholderWidth}
        animationDirection={{ type: 'horizontal' }}
        background={{ color: placeholderColor }}
        opacity={0.1}
      />
      {rest.width > minPossibleWidthForPath ? (
        <RectangleWithCustomRadius
          {...rest}
          animationDirection={{ type: 'horizontal' }}
        />
      ) : (
        <rect
          x={rest.x}
          y={rest.y}
          width={rest.width}
          height={rest.height}
          opacity={rest.opacity}
          rx={rest.topLeftRadius ? rest.topLeftRadius / 2 : 0}
          ry={rest.bottomLeftRadius ? rest.bottomLeftRadius / 2 : 0}
          fill={rest.background.color}
        />
      )}
    </svg>
  );
};
